<template>
    <div class="product">
        <div class="app-container pa-4">
            <breadcrumbs :product-data="productData" :breadcrumbs="breadcrumbs"></breadcrumbs>
            <v-row>
                <v-col sm="12" md="8" lg="8" order="first">
                    <main-info
                        :product-data="productData"
                        :product-rate="productRate"
                        @cart="actionCart"
                        @favorites="actionFavorites"
                        @order="actionOrder"
                        @feedback="actionProductFeedback"
                        @rating-change="ratingChange"
                        @message="actionMessage"
                    ></main-info>
                </v-col>
                <v-col sm="12" md="4" lg="4" order="last" order-md="2">
                    <seller-info
                        :product-data="productData"
                        :company-rate="companyRate"
                        @message="actionMessage"
                    ></seller-info>
                </v-col>
                <v-col sm="12" md="12" lg="12" order="2" order-md="last">
                    <characteristics
                        :product-data="productData"
                        :product-feedbacks="productFeedbacks"
                        @feedback="actionProductFeedback"
                    ></characteristics>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <products-you-like
                        :product="id"
                    ></products-you-like>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <products-visited
                        :products-ids="visitedProductsIds"
                    ></products-visited>
                </v-col>
            </v-row>
            <order-dialog
                :is-open="openOrderDialog"
                :order-type="orderDialogType"
                :order-ids="orderIds"
                @close="closeOrderDialog"
            ></order-dialog>
            <seller-dialog
                :type="sellerMessageType"
                :isOpen="sellerMessageOpen"
                :product="productData"
                @close="sellerMessageOpen = false"
            ></seller-dialog>
        </div>
        <auth-dialog :is-open="loginDialogStore"></auth-dialog>
        <product-feedback-dialog
            :isOpen="productFeedbackOpen"
            :product="product"
            :product-name="productName"
            @close="productFeedbackOpen = false"
            @feedback-change="feedbackChange()"
        ></product-feedback-dialog>
        <v-snackbar
            color="main--black"
            dark
            v-model="snackOpen"
            top
        >
            <div class="d-flex">
                <v-btn text class="text--main-yellow" link :to="`/profile/favorites`">{{ $t('favorites') }}</v-btn>
                <v-btn text icon @click="closeSnack">
                    <v-icon color="grey">close</v-icon>
                </v-btn>
            </div>
        </v-snackbar>
    </div>
</template>

<script>

    import ActionAccess from '../../../app-front/mixins/ActionAccess';
    import AddToBasket from '../../../app-front/mixins/AddToBasket';
    import AppBreadcrumbs from '../../../app-front/mixins/AppBreadcrumbs';
    import AppSnack from '../../../general/mixins/AppSnack';
    import AuthDialog from '../../../app-front/components/dialogs/AuthDialog';
    import BasketService from '../../../app-front/services/api/BasketService';
    import Breadcrumbs from '../../../app-front/components/breadcrumbs';
    import BuyWithProduct from '../../../app-front/components/product/buy-with-product/BuyWithProduct';
    import CompanyService from '../../../app-front/services/api/CompanyService';
    import Characteristics from './Characteristics';
    import Favorites from '../../../app-front/mixins/Favorites';
    import MainInfo from './MainInfo';
    import OrderDialog from '../../../../js/views/front/basket/OrderDialog';
    import ProductsYouLike from '../../../app-front/components/product/products-you-like/ProductsYouLike';
    import ProductService from '../../../app-front/services/api/ProductService';
    import ProductFeedbackDialog from '../../../app-front/components/dialogs/ProductFeedbackDialog';
    import ProductsAttributes from '../../../app-front/mixins/ProductsAttributes';
    import ProductsLocalStorage from '../../../app-front/mixins/ProductsLocalStorage';
    import ProductsVisited from '../../../app-front/components/product/products-visited/ProductsVisited';
    import SellerDialog from '../../../app-front/components/dialogs/ProductSellerDialog'
    import SellerInfo from './SellerInfo';
    import SellersTable from '../../../app-front/components/product/sellers-table/SellersTable';


    import './product-card.scss'

    export default {
        name: 'ProductCard',
        props: ['sysNameWithId'],
        mixins: [ActionAccess, AppBreadcrumbs, Favorites, AddToBasket, AppSnack, ProductsLocalStorage, ProductsAttributes],
        components: {
            AuthDialog,
            Breadcrumbs,
            BuyWithProduct,
            Characteristics,
            MainInfo,
            OrderDialog,
            ProductsYouLike,
            SellerDialog,
            SellerInfo,
            SellersTable,
            ProductFeedbackDialog,
            ProductsVisited,
        },
        data() {
            return {
                id: 0,
                metaUrl: '/products/' + this.id,
                productData: {},
                priceMessageOpen: false,
                priceMessageProduct: null,
                sellerMessageOpen: false,
                sellerMessageType: '',
                sellerMessageProduct: null,
                breadcrumbsData: {
                    page: 'productPage',
                    data: {
                        productId: this.id,
                    },
                },
                selected: [],
                loadingSellers: true,
                sellersTableData: {
                    headers: [],
                    body: [],
                },
                openOrderDialog: false,
                orderDialogType: null,
                orderIds: [],
                productCategoryId: {},
                companyRate: {
                    companyId: null,
                    value: null,
                    total: null,
                },
                productRate: {
                    productId: this.id,
                    value: null,
                    total: null,
                },
                companyId: null,
                productFeedbackMessage: null,
                productFeedbackOpen: false,
                productFeedbacks: [],
                productFeedbackTotal: null,
                result: {
                    css: '',
                    header: '',
                    id: null,
                },
            }
        },

        computed: {
            componentSystemValue() {
                return this.id;
            },
            loginDialogStore() {
                return this.$store.state.account.showLoginDialog;
            },
            productCategory() {
                return this.productData.category ? this.productData.category.id : null;
            },
            productName() {
                return this.productData.productName;
            },
            productPrice() {
                return this.productData.price ? this.productData.price.value : this.$t('contractual');
            },
            productPriceCurrency() {
                return this.productData.price ? this.productData.price.currency.toUpperCase() : '';
            },
            product() {
                return this.id;
            },
        },
        methods: {
            actionProductFeedback(product) {
                this.productFeedbackMessage = product;
                this.productFeedbackOpen = true;
            },
            authSuccessActionHandle(data) {
                switch (data.type) {
                    case 'favorites' :
                        this.actionFavorites();
                        break;
                    case 'order' :
                        this.actionOrder();
                        break;
                    case 'cart' :
                        this.actionCart();
                        break;
                    case 'message' :
                        this.actionMessage();
                        break;
                }
            },

            actionCart() {
                const product = {
                    id: this.componentSystemValue,
                    quantity: 1,
                };
                BasketService.updateList([product])
                    .then(res => {
                        this.$store.commit('setBasket', res.data);
                    })
                    .catch(err => {
                        console.log(err)
                    });
            },
            actionFavorites() {
                this.addFavorite(this.componentSystemValue);
                if (this.addFavorite) {
                    this.result.css = 'success';
                    this.result.header = this.$t('favorites');
                    this.openSnack();
                }
            },
            actionMessage({ type }) {
                this.sellerMessageProduct = this.componentSystemValue;
                this.sellerMessageType = type;
                this.sellerMessageOpen = true;
            },
            actionOrder() {
                this.orderIds = [this.componentSystemValue];
                this.orderDialogType = 'single';
                this.openOrderDialog = true;
            },
            closeOrderDialog() {
                this.openOrderDialog = false;
            },
            getData() {
                const filters = { product_id: [this.id] };
                ProductService.setLocale(this.$store.state.language.appLanguage);
                ProductService.getSingle(filters)
                    .then(res => {
                        this.productData = res.data;
                        this.productData.attributes.enumAttributes = this.getTransformedEnumAttributes(res.data.attributes);
                        this.getCompanyId(res.data);
                    })
                    .catch(err => {
                        console.log(err);
                    });

                this.getFeedbacks();
                this.ratingChange();
            },
            getCompanyId(data) {
                this.companyId = data.seller.companyId;

                if (this.companyId) {
                    CompanyService.getCompanyRate(this.companyId)
                        .then(res => {
                            this.companyRate = res.data;
                        })
                        .catch(err => {
                            console.log(err);
                        });
                }
            },
            getDistributors() {
                const filters = {};
                filters[this.$store.state.filters.general.category.systemName] = this.productCategory;
                filters[this.$store.state.filters.general.productSystemName.systemName] = this.productData.productSystemName;

                ProductService.getDistributorsTable(filters)
                    .then(res => {
                        this.sellersTableData = res.data;
                        this.loadingSellers = false;
                        this.exceptedSellers(res.data);
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            exceptedSellers(data) {
                const result = data.body.filter(item => {
                    return item.id !== this.productData.id;
                });

                this.sellersTableData.body = Object.values(result);
            },
            getFeedbacks() {
                ProductService.getProductFeedback(this.id)
                    .then(res => {
                        this.productFeedbacks = res.data;
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            getRating() {
                ProductService.getProductRate(this.id)
                    .then(res => {
                        this.productRate = res.data;
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            feedbackChange() {
                this.getFeedbacks();
            },
            ratingChange() {
                this.getRating();
            },
            reset() {
                this.metaUrl = '/products/' + this.id;
                this.breadcrumbsData.data.productId = this.id;
                this.setBreadcrumbs();
                this.getMetaData();
                this.getData();
            },
            showSellersTable() {
                this.sellersShow = !this.sellersShow;
                this.getDistributors();
            },
            getId() {
                this.id = this.sysNameWithId.split('-').reverse()[0];
                this.metaUrl = '/products/' + this.id;
                this.breadcrumbsData.data.productId = this.id;
            },
        },
        created() {
            this.getId();
            this.getData();
        },
        watch: {
            sysNameWithId() {
                this.getId();
                this.reset();
            },
        },
    }
</script>
